// Polyfill to make React available via require() for use-sync-external-store-shim
// This must run before any code that uses require("react")
// CRITICAL: This file must be imported FIRST in main.jsx

import * as React from 'react'

// Set React globally FIRST - this is critical for use-sync-external-store-shim
// Do this synchronously before any other code runs
if (typeof window !== 'undefined') {
  window.React = React
  // Ensure React.default is also available (some code expects this)
  if (!window.React.default) {
    window.React.default = React
  }
}
if (typeof globalThis !== 'undefined') {
  globalThis.React = React
  if (!globalThis.React.default) {
    globalThis.React.default = React
  }
}

// Create require polyfill for CommonJS modules (like use-sync-external-store-shim)
// This allows require("react") to work in the bundled code
const moduleCache = {
  'react': React
}

const requirePolyfill = function require(moduleName) {
  if (moduleCache[moduleName]) {
    return moduleCache[moduleName]
  }
  // Try to get from global React if available
  if (moduleName === 'react' && typeof window !== 'undefined' && window.React) {
    return window.React
  }
  throw new Error(`Cannot find module '${moduleName}'`)
}

// Set require on window and globalThis BEFORE any modules load
if (typeof window !== 'undefined') {
  // Don't override if already exists (might be set by build system)
  if (!window.require || typeof window.require !== 'function') {
    window.require = requirePolyfill
  } else {
    // Wrap existing require to add React support
    const originalRequire = window.require
    window.require = function(moduleName) {
      if (moduleName === 'react') {
        return React
      }
      return originalRequire(moduleName)
    }
  }
}
if (typeof globalThis !== 'undefined') {
  if (!globalThis.require || typeof globalThis.require !== 'function') {
    globalThis.require = requirePolyfill
  } else {
    const originalRequire = globalThis.require
    globalThis.require = function(moduleName) {
      if (moduleName === 'react') {
        return React
      }
      return originalRequire(moduleName)
    }
  }
}

export default React

